import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { UserService } from '~services/user.service';
import { EmailSettingsV2Service } from '~services/email-settings-v2.service';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { EmailData, LoaderIntegrationLoad } from '~models/emailSettings.model';

@Component({
  selector: 'sa-loads-on-date',
  templateUrl: './loads-on-date.component.html',
  styleUrls: ['./loads-on-date.component.scss'],
})
export class LoadsOnDateComponent implements OnInit, OnDestroy {
  activeDataSource: MatTableDataSource<LoaderIntegrationLoad>;
  displayedColumns = [
    'uploadTime',
    'poNumber',
    'bolNumber',
    'pickupTime',
    'truckNumber',
    'potentialMatchCount',
    'orderId',
    'matchReasons',
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  subscriptions: Subscription[] = [];

  public emailData$: Observable<EmailData>;

  public filter = 'all';

  private filter$$ = new BehaviorSubject<string>('all');

  public loaderTimezone: string;

  constructor(
    private route: ActivatedRoute,
    public emailSettingsService: EmailSettingsV2Service,
    public userService: UserService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.activeDataSource = new MatTableDataSource([]);
    this.activeDataSource.sort = this.sort;

    this.emailData$ = this.emailSettingsService.emailData$;

    this.filter = this.route.snapshot.queryParams['filter'];
    if (this.filter !== 'matched' && this.filter !== 'unmatched' && this.filter !== 'all') {
      this.router.navigate([], { queryParams: { filter: 'all' } });
      this.filter = 'all';
    }

    this.filter$$.next(this.filter);

    this.subscriptions.push(
      combineLatest([this.emailSettingsService.loadsForDate$, this.filter$$]).subscribe(([loads, filter]) => {
        if (loads) {
          this.activeDataSource.data = this.filterLoads(loads, filter);
        } else {
          this.activeDataSource.data = [];
        }
      }),
      this.emailData$.subscribe((emailData) => {
        if (emailData) {
          this.loaderTimezone = emailData.loaderTimezone;
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  public toMatchReasonText(matchReason: string, loadData: LoaderIntegrationLoad): string {
    const matchReasonMap = {
      site_visit: 'Mine Site Visit Time',
      bol_number: 'BOL Number',
      po_number: 'PO Number',
      truck_number: 'Truck Number',
    };

    if (matchReason === 'partial_truck_number') {
      return `Partial Truck Number (${loadData.partialTruckNumberMatchLength} chars)`;
    }

    return matchReasonMap[matchReason];
  }

  public filterTypeChange() {
    this.router.navigate([], { queryParams: { filter: this.filter }, skipLocationChange: true });
    this.filter$$.next(this.filter);
  }

  private filterLoads(loads: LoaderIntegrationLoad[], filter: string): LoaderIntegrationLoad[] {
    if (filter === 'matched') {
      return loads.filter((load) => load.matched);
    }

    if (filter === 'unmatched') {
      return loads.filter((load) => !load.matched);
    }

    return loads;
  }
}
